import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICreateReportExecutorProps } from './ICreateReportExecutorProps';
import { CreateReportExecutorModal } from './CreateReportExecutorModal';

export const CreateReportExecutor = createDocModalExecutor<ICreateReportExecutorProps>({
    modal: CreateReportExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        runInBackground: action.options?.runInBackground ?? false,
        completeHandler,
    }),
});
